export default "__VITE_ASSET__D$j$qPnX__"